import { Link } from "react-router-dom";

interface ManhwaCardProps {
  slug: string;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  categoryName: string;
  chapters: number;
  status: string;
  updatedAt: string;
}

export default function ManhwaCard({
  slug,
  title,
  author,
  cover,
  rating,
  views,
  categoryName,
  chapters,
  status,
  updatedAt,
}: ManhwaCardProps) {
  return (
    <Link
      to={`/manhwa/${slug}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:translate-y-[-2px]"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary-500 text-white">
            {categoryName}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
              status === "已完结"
                ? "bg-secondary-500 text-white"
                : "bg-accent-500 text-white"
            }`}
          >
            {status}
          </span>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{author}</p>

        <div className="mt-3 flex items-center justify-between">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-amber-400 text-xs" />
            <span className="text-xs font-medium text-foreground-700">{rating}</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-file-list-3-line text-xs text-foreground-400" />
            <span className="text-xs text-foreground-500">{chapters}话</span>
          </div>
          <span className="text-xs text-foreground-400">
            {formatViews(views)}
          </span>
        </div>
      </div>
    </Link>
  );
}

function formatViews(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  }
  if (num >= 10000) {
    return (num / 10000).toFixed(1) + "万";
  }
  return num.toString();
}